<template>
  <div class="widget widget-primary widget-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="mb-5 mt-5">{{ $translate("Phywe::Template.manSearchTitle") }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5">
        <div class="grey-box ">
          <h3>{{ $translate("Phywe::Template.manSearchDesc") }}</h3>
          <div class="input-unit mt-4">
            <input type="text" name="quickbuy" id="quickbuy" autocomplete="quickbuy" @keyup="searchItems($event)">
            <label for="quickbuy">{{ $translate("Phywe::Template.manArtikelNr") }}</label>
          </div>
          <template v-if="textSearch.length > 0">
            <h3>{{ $translate("Phywe::Template.manSearchMeaning") }}</h3>
            <div class="basket-list-item py-3" v-for="item in textSearch" @click="searchSingleItem(item)">

              <div class="basket-item component-loading with-icon d-flex">
                <div class="image-container">
                  <img :src="item.image" class="img-fluid">
                </div>
                <div class="meta-container-wrapper">
                  <div class="meta-container-wrapper-inner">
                    <div class="meta-container">
                      <div class="position-relative w-100">

                        <div class="text-muted small">
                          {{ item.beforeLabel }}
                        </div>
                        <a href="#" class="item-name text-primary text-appearance small font-weight-bold text-break">
                          {{ item.label }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
      <div class="col-lg-7 mt-2 mt-lg-0">
        <div class="grey-box">
          <h3>{{ $translate("Phywe::Template.manSearchFoundDocs") }}</h3>
          <div>
            <template v-if="loading === true">
              <div class="d-flex justify-content-center" >
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </template>
            <template v-else>
              <ul v-if="foundItems.length == 0">
                <li>
                  {{ $translate("Phywe::Template.manSearchNoResult") }}
                </li>
              </ul>
              <ul v-if="foundItems.length > 0" class="list-inline filterbuttons mt-3">
                <template v-if="fileTypes.all > 0">
                  <li class="list-inline-item " @click="switchShowFiles('all')" :class="{'active' : showFiles == 'all'}">{{ $translate("Phywe::Template.alleFilter") }} ({{fileTypes.all}})</li>
                </template>
                <template v-if="fileTypes.pdf > 0">
                  <li class="list-inline-item" @click="switchShowFiles('pdf')" :class="{'active' : showFiles == 'pdf'}">pdf ({{fileTypes.pdf}})</li>
                </template>
                <template v-if="fileTypes.exe > 0">
                  <li class="list-inline-item" @click="switchShowFiles('exe')" :class="{'active' : showFiles == 'exe'}">exe ({{fileTypes.exe}})</li>
                </template>
                <template v-if="fileTypes.dmg > 0">
                  <li class="list-inline-item" @click="switchShowFiles('dmg')" :class="{'active' : showFiles == 'dmg'}">dmg ({{fileTypes.dmg}})</li>
                </template>
                <template v-if="fileTypes.msi > 0">
                  <li class="list-inline-item" @click="switchShowFiles('msi')" :class="{'active' : showFiles == 'msi'}">msi ({{fileTypes.msi}})</li>
                </template>
                <template v-if="fileTypes.pkg > 0">
                  <li class="list-inline-item" @click="switchShowFiles('pkg')" :class="{'active' : showFiles == 'pkg'}">pkg ({{fileTypes.pkg}})</li>
                </template>
              </ul>
              <template  v-if="foundItems.length > 0">
                <div class="card-body px-0">
                  <div class="widget-listforitems">
                    <div class="row mt-0 mb-4 d-none d-lg-flex">
                      <div class="col-12 col-lg-7">&nbsp;</div>
                      <div class="d-none d-lg-block col-lg-1">&nbsp;</div>
                      <div class="d-none d-lg-block col-lg-2">{{ $translate("Phywe::Template.sbindingTableCell3") }}</div>
                      <div class="d-none d-lg-block col-lg-2 text-center">{{ $translate("Phywe::Template.sbindingTableCell5") }}</div>
                    </div>
                    <div class="itemslist">
                      <template v-for="media in foundItems" v-if="showFiles == media.fileExtension || showFiles == 'all'">
                        <template v-if="media.fileExtension == 'exe' || media.fileExtension=='msi' || media.fileExtension=='pkg' || media.fileExtension=='dmg'">
                          <div class="row itemblocks mt-3">
                            <div class="col-10 col-lg-9 order-0 order-lg-0">
                              <a v-html="media.fileExternalComment" class="cursor" :href="media.fileInternalComment" target="_blank"></a>
                            </div>
                            <div class="col-12 col-lg-2 order-2 order-lg-1">
                              <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell3") }}</span>
                              <span></span>
                            </div>
                            <div class="d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center">
                              <div v-html="media.fileExtension"></div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="row itemblocks mt-3">
                            <div class="col-10 col-lg-8 order-0 order-lg-0">
                              <div v-html="media.realName" @click="getFileContent(media.id)" class="cursor"></div>
                            </div>
                            <div class="col-12 col-lg-2 order-2 order-lg-1">
                              <span class="d-lg-none text-muted">{{ $translate("Phywe::Template.sbindingTableCell3") }}</span>
                              <span>{{ (media.fileSize / 1000000).toFixed(2) }} Mb</span>
                            </div>
                            <div class="d-none d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-center">
                              <div v-html="media.fileExtension"></div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default
{
  data: function()
  {
    return {
      manuals:[],
      loading:false,
      nothingfound:false,
      textSearch:[],
      showFiles:'all',
      fileTypes:
          {
            'all':0,
            'pdf':0,
            'exe':0,
            'dmg':0,
            'msi':0,
            'pkg':0
          }
    };
  },
  methods:
  {
    switchShowFiles:function(type)
    {
      let _self = this;
      _self.showFiles = type;
    },
    pushTypeValue:function(type)
    {
      let _self = this;
      _self.fileTypes[type] = _self.fileTypes[type]+1
    },
    getFileContent: function(id)
    {
      let _self = this;
      $.ajax(
          {
            type: 'GET',
            url: '/'+App.language+'/Ybba/MediaFiles/get/mf/'+id,
            dataType: 'json',
            success: function (data)
            {
              const byteString    = window.atob( data.data );
              const arrayBuffer   = byteString.length;
              const int8Array     = new Uint8Array(arrayBuffer);
              for (let i = 0; i < byteString.length; i++)
              {
                int8Array[i] = byteString.charCodeAt(i);
              }
              let type = '';
              // https://www.sitepoint.com/mime-types-complete-list/
              if(data.type == 'pkg')
              {
                type = 'application/x-newton-compatible-pkg'
              }
              if(data.type == 'pdf')
              {
                type = 'application/pdf'
              }
              if(data.type == 'exe')
              {
                type = 'application/octet-stream'
              }
              if(data.type == 'jpg')
              {
                type = 'image/jpeg'
              }
              if(data.type == 'png')
              {
                type = 'image/png'
              }

              const blob      = new Blob([int8Array], { type: type} );
              const url       = window.URL.createObjectURL( blob );
              var anchor      = document.createElement("a");
              anchor.download = data.name+'.'+data.type;
              anchor.href     = url;
              anchor.click();
            },
            error: function (response)
            {
              console.log(response);
            }
          })
    },
    searchSingleItem(item)
    {
      let _self = this;
      var itemsplit2 = item.url.split('_');
      let itemId = itemsplit2[1];
      $.ajax(
          {
            type:           'GET',
            url:            '/'+App.language+'/getnumber/'+itemId+'/' + App.language,
            dataType:       'json',
            success:        function(response)
            {
              if(response.documents[0].data.variation.number)
              {
                let event =
                    {
                      target:
                          {
                            value:response.documents[0].data.variation.number
                          }
                    }
                _self.textSearch = [];
                _self.searchItems(event);
              }
            },
            error:          function(jqXHR, textStatus, errorThrown)
            {
              console.error(errorThrown);
            }
          });
    },
    searchItems:function (event)
    {

      if(event.target.value.length > 3)
      {

        let _self           = this;
        _self.fileTypes     =
            {
              'all':0,
              'pdf':0,
              'exe':0,
              'dmg':0,
              'msi':0,
              'pkg':0
            };
        _self.textSearch    = [];
        _self.showFiles     = 'all';
        _self.loading       = true;
        _self.nothingfound  = false;
        _self.manuals       = [];
        $.ajax(
            {
              type: 'GET',
              url: '/'+App.language+'/items/getid/' + event.target.value + '/' + App.language,
              dataType: 'json',
              success: function (data)
              {
                if(data.entries.length > 0)
                {
                  $.ajax(
                      {
                        type: 'GET',
                        url: '/'+App.language+'/Ybba/MediaFiles/get/item/' + data.entries[0].itemId,
                        dataType: 'json',
                        success: function (data)
                        {
                          for(let i=0; i<data.length;i++)
                          {
                            if(data[i].type != 'KUNDENZITAT')
                            {
                              data[i].realName = "("+data[i].lang+")"+' '+data[i].fileExternalComment;
                              _self.manuals.push(data[i]);
                              _self.pushTypeValue(data[i].fileExtension);
                              _self.pushTypeValue('all');
                            }
                          }
                          _self.loading = false;
                        },
                        error: function (jqXHR, textStatus, errorThrown)
                        {
                          console.error(errorThrown);
                          _self.loading = false;
                        }
                      });
                }
                else
                {

                  $.ajax(
                      {
                        type:           'GET',
                        url:            '/rest/io/item/search/autocomplete/?query='+event.target.value+'&types%5B%5D=item&types%5B%5D=suggestion',
                        dataType:       'json',
                        success:        function(response)
                        {
                          _self.textSearch    = response.data.item;
                          _self.loading       = false;
                          _self.nothingfound  = true;
                        },
                        error:          function(jqXHR, textStatus, errorThrown)
                        {
                          console.error(errorThrown);
                        }
                      });



                }
              },
              error: function (jqXHR, textStatus, errorThrown)
              {
                console.error(errorThrown);
                _self.loading = false;
              }
            });
      }
    }
  },
  computed:
  {
    foundItems: function()
    {
      return this.manuals
    }
  }
}
</script>
